const schema = {
    SUMA: {
        company_id: 'cabcb4a6-2d47-4f5e-b85d-5be8d4ab61a1',
        system_name: 'accurate'
    },
    GP: {
        company_id: 'aa2c63cf-3230-48e0-bbb6-bfe68542e14c',
        system_name: 'accurate'
    }
};

export const integration = (key) => {
    const config = schema[key];
    if (!config) throw new Error(`Integration config not found for key: "${key}"`);
    return config;
};